import {
  GET_OPERATORS_LIST,
  GET_OPERATOR_BY_ID,
  GET_TRIPS,
  DOWNLOAD_LEDGER,
  GET_FILE_UPLOAD,
  GET_TDS_FILE_UPLOAD,
  GET_FILE_VIEW,
  RESET_FILE_URL,
  UPDATE_BASIC_DETAILS,
  UPDATE_COMPANY_DETAILS,
  SAVE_RC_LINK,
  RESET_VEHICLES,
  UPDATE_DOCUMENTS,
  GET_VEHICLES_LIST,
  GET_RC_LINK,
  UPDATE_COMPLIANCES,
  VIEW_RC,
  RESET_RC_VIEW,
  RESET_ACTIVE_VEHICLE,
  CREATE_OPERATOR,
  RESET_EDIT_STATUS,
  CREATE_BANK_ACCOUNT,
  EDIT_BANK_ACCOUNT,
  VERIFY_BANK_ACCOUNT_OTP,
  RESEND_BANK_ACCOUNT_OTP,
  CLEAR_BANK_ACCOUNT_OTP,
  SET_ACTIVE_VEHICLE,
  DISABLE_ACCOUNT,
  SEND_TO_THIRD_PARTY,
  CREATE_OPERATOR_VEHICLE,
  SETTLE_TRIP,
  GET_BANK_ACCOUNT,
  RESET_UPLOAD_STATUS,
  GET_OPERATOR_SEARCH,
  RESET_SETTLED_STATUS,
  RESET_UNSETTLED,
  RESET_SETTLED,
  GET_OPERATOR_TYPE,
  GET_OPERATOR_STATUS,
  RESET_OPERATOR_LIST,
  RESET_TDS_FILE_URL,
  GET_TDS_VIEW_URL,
  ADD_TDS_DEC,
  EDIT_TDS_DEC,
  RESET_TDS_ERROR_MSG,
  UNCHECK_FLAGS,
  GET_LANES_OPTIONS,
  EDIT_ONBOARDING_DEATILS,
  GET_BASIC_DETAILS_OPERATOR,
  GET_ADDRESS_DETAILS_OPERATOR,
  GET_COMPLIANCES_DETAILS_OPERATOR,
  GET_DOCUMENT_DETAILS_OPERATOR,
  GET_VEHICLE_DETAILS_OPERATOR,
  UPDATE_OPERATOR_BASIC_DETAILS,
  UPDATE_OPERATOR_ADDRESS_DETAILS,
  UPDATE_OPERATOR_COMPLAINCES_DETAILS,
  UPDATE_OPERATOR_VEHICLES_DETAILS,
  VIEW_UPLOADED_DOCUMENT,
  SEND_UNDERTAKING_LINK,
  SEND_TDS_LINK,
  UPLOAD_OPERATOR_IDENTITY_DOCUMENTS,
  UPDATE_OPERATOR_TDS_DETAILS,
  UPDATE_OPERATOR_DOCUMENT_DETAILS,
  GET_OPERATOR_BY_OPCODE,
  GET_ODVT_LIST,
  GET_VEHICLE_INFO,
  GET_VEHICLE_INFO_SUCCESS,
  GET_VEHICLE_INFO_FAILURE,
  GET_KYC_HISTORY,
  GET_KYC_HISTORY_SUCCESS,
  GET_KYC_STATUS_REMARKS,
  GET_PHONE_NO,
} from './actions';

import { REQUEST, SUCCESS, FAILURE } from '../../../utils/actionGenerator';

const defaultState = {
  operatorsList: [],
  selectedOperator: {},
  operatorBasicDetails: {},
  operatorAddressDetails: {},
  uploadedDocumentViewUrl: '',
  operatorCompliancesDetails: {},
  operatorDocumentDetails: {},
  operatorVehicleDetails: {},
  identityDocumentUploadDetails: {},
  identityDocData: {},
  basicDetailsUpdated: false,
  compliancesUpdated: false,
  companyDetailsUpdated: false,
  undertakingLinkSentStatus: false,
  tdsLinkSentStatus: false,
  documentsUpdated: false,
  operatorCreated: false,
  bankCreated: false,
  rcSaved: false,
  bankEdited: false,
  bankDisabled: false,
  tripSettled: false,
  rcUploaded: false,
  operatorBasicDetailsUpdated: false,
  operatorAddressDetailsUpdated: false,
  operatorCompliancesDetailsUpdated: false,
  operatorVehicleDetailsUpdated: false,
  operatorDocumentDetailsUpdated: false,
  operatorIdentityDocumentUploaded: false,
  operatorTdsDetailsUploaded: false,
  frontRC: '',
  backRC: '',
  frontRcName: '',
  rcView: '',
  backRcName: '',
  frontImgResourceKey: '',
  backImgResourceKey: '',
  vehDecFrontResourceKey: '',
  sentToThirdParty: false,
  bankAccounts: [],
  ledger: '',
  aadharUploaded: false,
  chequeUploaded: false,
  vehicleCount: null,
  vehicleUpdated: false,
  panUploaded: false,
  vehiclesList: [],
  activeVehicle: {},
  fileName: '',
  fileUrl: '',
  tdsFileUrl: '',
  unsettledTrips: [],
  settledTrips: [],
  operatorDocuments: {},
  companyDetails: [],
  searchResults: [],
  unsettledObject: {},
  settledObject: {},
  totalRecoveryAmount: null,
  operatorTypes: [],
  operatorStatuses: [],
  tripCount: {},
  tdsValues: [],
  tdsFileUploaded: false,
  tdsFileName: '',
  addedTdsDeclaration: '',
  updatedTdsDeclaration: '',
  addTdsDecErrorMsg: '',
  editCompliancesMsg: '',
  zonesWithDestinations: [],
  onboardingDetailsUpdated: false,
  onboardingDetailsUpdateFailMsg: '',
  createOperatorFailMsg: '',
  tdsLinkErrorMessage: '',
  undertakingLinkErrorMessage: '',
  createVehicleFailMsg: '',
  updateVehicleFailMsg: '',
  odvtList: [],
  isFetchingOdvtList: false,
  vehicleSearchInfo: {
    isFetching: false,
    vehicleData: {},
  },
  kycHistory: [],
  kycRemarks: [],
  phoneNo: '',
  bankAccountOtpDetails: null,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_OPERATORS_LIST[REQUEST]:
      return { ...state };
    case GET_OPERATORS_LIST[SUCCESS]:
      return { ...state, operatorsList: state.operatorsList.concat(action.response.operators) };
    case GET_OPERATOR_TYPE[REQUEST]:
      return { ...state, operatorTypes: [] };
    case GET_OPERATOR_TYPE[SUCCESS]:
      return { ...state, operatorTypes: action.response };
    case GET_OPERATOR_STATUS[REQUEST]:
      return { ...state, operatorStatuses: [] };
    case GET_OPERATOR_STATUS[SUCCESS]:
      return { ...state, operatorStatuses: action.response };
    case GET_PHONE_NO[REQUEST]:
      return { ...state, phoneNo: '' };
    case GET_PHONE_NO[SUCCESS]:
      return { ...state, phoneNo: action.response };
    case GET_PHONE_NO[FAILURE]:
      return { ...state, phoneNo: '' };
    case RESET_UNSETTLED:
      return { ...state, unsettledTrips: [], unsettledObject: {} };
    case RESET_VEHICLES:
      return { ...state, vehiclesList: [] };
    case UNCHECK_FLAGS:
      return { ...state, addedTdsDeclaration: false, updatedTdsDeclaration: false, createOperatorFailMsg: '' };
    case RESET_SETTLED:
      return { ...state, settledTrips: [], settledObject: {}, totalRecoveryAmount: null };
    case RESET_OPERATOR_LIST:
      return { ...state, operatorsList: [] };
    case RESET_ACTIVE_VEHICLE:
      return { ...state, activeVehicle: {} };
    case GET_OPERATOR_SEARCH[REQUEST]:
      return { ...state };
    case SET_ACTIVE_VEHICLE:
      return { ...state, activeVehicle: action.payload };
    case GET_OPERATOR_SEARCH[SUCCESS]:
      return { ...state, searchResults: action.response.operators ?? [] };
    case GET_BANK_ACCOUNT[REQUEST]:
      return { ...state, bankAccounts: [] };
    case GET_BANK_ACCOUNT[SUCCESS]:
      return { ...state, bankAccounts: action.response };
    case VIEW_RC:
      return { ...state, rcView: action.payload };
    case RESET_RC_VIEW:
      return { ...state, rcView: '' };
    case GET_RC_LINK[REQUEST]:
      return { ...state, rcUploaded: false };
    case GET_RC_LINK[SUCCESS]:
      if (action.payload.type === 'front') {
        return { ...state, frontRC: action.response, rcUploaded: true, frontRcName: 'Front_RC.img' };
      } else if (action.payload.type === 'back') {
        return { ...state, backRC: action.response, rcUploaded: true, backRcName: 'Back_RC.img' };
      } else {
        return { ...state };
      }
    case RESET_SETTLED_STATUS:
      return { ...state, tripSettled: false };
    case GET_OPERATOR_BY_ID[REQUEST]:
      return { ...state, selectedOperator: {} };
    case GET_OPERATOR_BY_ID[SUCCESS]:
      return {
        ...state,
        selectedOperator: action.response[0].data.data,
        operatorDocuments: action.response[1].data.data,
        companyDetails: action.response[2].data.data,
        tripCount: action.response[3].data.data,
      };
    case GET_OPERATOR_BY_OPCODE[REQUEST]:
      return {
        ...state,
        operatorBasicDetails: {},
        phoneNo: '',
        operatorAddressDetails: {},
        operatorCompliancesDetails: {},
        operatorDocumentDetails: {},
      };
    case GET_OPERATOR_BY_OPCODE[SUCCESS]:
      return {
        ...state,
        operatorBasicDetails: action.response[0].data.data,
        operatorAddressDetails: action.response[1].data.data,
        operatorCompliancesDetails: action.response[2].data.data,
        operatorDocumentDetails: action.response[3].data.data,
      };

    case GET_BASIC_DETAILS_OPERATOR[REQUEST]:
      return {
        ...state,
        phoneNo: '',
        operatorBasicDetails: {},
      };
    case GET_BASIC_DETAILS_OPERATOR[SUCCESS]:
      return {
        ...state,
        operatorBasicDetails: action.response[0].data.data,
      };

    case GET_ADDRESS_DETAILS_OPERATOR[REQUEST]:
      return {
        ...state,
        operatorAddressDetails: {},
      };
    case GET_ADDRESS_DETAILS_OPERATOR[SUCCESS]:
      return {
        ...state,
        operatorAddressDetails: action.response[0].data.data,
      };

    case GET_COMPLIANCES_DETAILS_OPERATOR[REQUEST]:
      return {
        ...state,
        operatorCompliancesDetails: {},
      };
    case GET_COMPLIANCES_DETAILS_OPERATOR[SUCCESS]:
      return {
        ...state,
        operatorCompliancesDetails: action.response[0].data.data,
      };

    case GET_DOCUMENT_DETAILS_OPERATOR[REQUEST]:
      return {
        ...state,
        operatorDocumentDetails: {},
      };
    case GET_DOCUMENT_DETAILS_OPERATOR[SUCCESS]:
      return {
        ...state,
        operatorDocumentDetails: action.response[0].data.data,
      };

    case GET_VEHICLE_DETAILS_OPERATOR[REQUEST]:
      return {
        ...state,
        operatorVehicleDetails: {},
      };
    case GET_VEHICLE_DETAILS_OPERATOR[SUCCESS]:
      return {
        ...state,
        operatorVehicleDetails: action.response[0].data.data,
      };
    case VIEW_UPLOADED_DOCUMENT[REQUEST]:
      return {
        ...state,
        uploadedDocumentViewUrl: {},
      };
    case VIEW_UPLOADED_DOCUMENT[SUCCESS]:
      return {
        ...state,
        uploadedDocumentViewUrl: action.response[0].data.data,
      };
    case SEND_UNDERTAKING_LINK[REQUEST]:
      return {
        ...state,
        undertakingLinkSentStatus: false,
        undertakingLinkErrorMessage: '',
      };
    case SEND_UNDERTAKING_LINK[SUCCESS]:
      return {
        ...state,
        undertakingLinkSentStatus: true,
      };
    case SEND_UNDERTAKING_LINK[FAILURE]:
      return {
        ...state,
        undertakingLinkSentStatus: false,
        undertakingLinkErrorMessage: action.response.response.data.message,
      };
    case SEND_TDS_LINK[REQUEST]:
      return {
        ...state,
        tdsLinkSentStatus: false,
        tdsLinkErrorMessage: '',
      };
    case SEND_TDS_LINK[SUCCESS]:
      return {
        ...state,
        tdsLinkSentStatus: true,
      };
    case SEND_TDS_LINK[FAILURE]:
      return {
        ...state,
        tdsLinkSentStatus: false,
        tdsLinkErrorMessage: action.response.response.data.message,
      };
    case GET_TRIPS[REQUEST]:
      return { ...state };
    case GET_TRIPS[SUCCESS]:
      const { response } = action;
      
      // Handling both v2 and v3 schemas: response may be { consignments, totalRecoveryAmount } or { data: { consignments, totalRecoveryAmount } }
      const consignments = response.data?.consignments ?? response.consignments ?? [];
      const totalRecoveryAmount = response.data?.totalRecoveryAmount ?? response.totalRecoveryAmount ?? null;

      if (action.params.settled)
        return {
          ...state,
          unsettledTrips: [],
          unsettledObject: {},
          settledTrips: state.settledTrips.concat(consignments),
          settledObject: { ...response, consignments: undefined },
          totalRecoveryAmount: totalRecoveryAmount != null ? totalRecoveryAmount : state.totalRecoveryAmount,
        };
      else
        return {
          ...state,
          unsettledTrips: state.unsettledTrips.concat(consignments),
          settledTrips: [],
          unsettledObject: { ...response, consignments: undefined },
          settledObject: {},
        };
    case GET_VEHICLES_LIST[REQUEST]:
      return { ...state };
    case GET_VEHICLES_LIST[SUCCESS]:
      return {
        ...state,
        vehiclesList: state.vehiclesList.concat(action.response.vehicles),
        vehicleCount: action.response.count,
      };
    case CREATE_OPERATOR[REQUEST]:
      return { ...state, operatorCreated: false, createOperatorFailMsg: '' };
    case CREATE_OPERATOR[SUCCESS]:
      return { ...state, operatorCreated: true };
    case CREATE_OPERATOR[FAILURE]:
      return { ...state, operatorCreated: false, createOperatorFailMsg: action.response.message };
    case CREATE_OPERATOR_VEHICLE[REQUEST]:
      return { ...state, vehicleUpdated: false };
    case CREATE_OPERATOR_VEHICLE[SUCCESS]:
      return { ...state, vehicleUpdated: true, createVehicleFailMsg: 'OK' };
    case CREATE_OPERATOR_VEHICLE[FAILURE]:
      return { ...state, vehicleUpdated: false, createVehicleFailMsg: action.response.message };
    case SAVE_RC_LINK[REQUEST]:
      return { ...state, rcSaved: false };
    case SAVE_RC_LINK[SUCCESS]:
      return { ...state, rcSaved: true };
    case RESET_FILE_URL:
      return { ...state, fileUrl: '' };
    case RESET_TDS_FILE_URL:
      return { ...state, tdsFileUrl: '' };
    case RESET_TDS_ERROR_MSG:
      return { ...state, addTdsDecErrorMsg: '', editPanFailMsg: '' };
    case RESET_EDIT_STATUS:
      return {
        ...state,
        basicDetailsUpdated: false,
        compliancesUpdated: false,
        companyDetailsUpdated: false,
        documentsUpdated: false,
        bankCreated: false,
        bankEdited: false,
        bankDisabled: false,
        sentToThirdParty: false,
        onboardingDetailsUpdated: false,
      };
    case DOWNLOAD_LEDGER[REQUEST]:
      return { ...state, ledger: '' };
    case DOWNLOAD_LEDGER[SUCCESS]:
      return { ...state, ledger: action.response };
    case RESET_UPLOAD_STATUS:
      return { ...state, aadharUploaded: false, chequeUploaded: false, panUploaded: false };
    case UPDATE_BASIC_DETAILS[REQUEST]:
      return { ...state, basicDetailsUpdated: false };
    case UPDATE_BASIC_DETAILS[SUCCESS]:
      return { ...state, basicDetailsUpdated: true };
    case UPDATE_COMPLIANCES[REQUEST]:
      return { ...state, compliancesUpdated: false, editPanFailMsg: '' };
    case UPDATE_COMPLIANCES[SUCCESS]:
      return { ...state, compliancesUpdated: true };
    case UPDATE_COMPLIANCES[FAILURE]:
      return { ...state, compliancesUpdated: false, editPanFailMsg: action.response.message };
    case UPDATE_COMPANY_DETAILS[REQUEST]:
      return { ...state, companyDetailsUpdated: false };
    case UPDATE_COMPANY_DETAILS[SUCCESS]:
      return { ...state, companyDetailsUpdated: true };
    case UPDATE_DOCUMENTS[REQUEST]:
      return { ...state, documentsUpdated: false };
    case UPDATE_DOCUMENTS[SUCCESS]:
      return { ...state, documentsUpdated: true };

    case UPDATE_OPERATOR_BASIC_DETAILS[REQUEST]:
      return { ...state, operatorBasicDetailsUpdated: false };
    case UPDATE_OPERATOR_BASIC_DETAILS[SUCCESS]:
      return { ...state, operatorBasicDetailsUpdated: true };
    case UPDATE_OPERATOR_ADDRESS_DETAILS[REQUEST]:
      return { ...state, operatorAddressDetailsUpdated: false };
    case UPDATE_OPERATOR_ADDRESS_DETAILS[SUCCESS]:
      return { ...state, operatorAddressDetailsUpdated: true };
    case UPDATE_OPERATOR_COMPLAINCES_DETAILS[REQUEST]:
      return { ...state, operatorCompliancesDetailsUpdated: false };
    case UPDATE_OPERATOR_COMPLAINCES_DETAILS[SUCCESS]:
      return { ...state, operatorCompliancesDetailsUpdated: true };
    case UPDATE_OPERATOR_VEHICLES_DETAILS[REQUEST]:
      return { ...state, operatorVehicleDetailsUpdated: false, updateVehicleFailMsg: '' };
    case UPDATE_OPERATOR_VEHICLES_DETAILS[SUCCESS]:
      return {
        ...state,
        operatorVehicleDetailsUpdated: true,
        updateVehicleFailMsg: 'VEHICLE DETAILS UPDATED SUCCESSFULLY',
      };
    case UPDATE_OPERATOR_VEHICLES_DETAILS[FAILURE]:
      return {
        ...state,
        operatorVehicleDetailsUpdated: false,
        updateVehicleFailMsg: action.response.message,
      };
    case UPDATE_OPERATOR_DOCUMENT_DETAILS[REQUEST]:
      return { ...state, operatorDocumentDetailsUpdated: false };
    case UPDATE_OPERATOR_DOCUMENT_DETAILS[SUCCESS]:
      return { ...state, operatorDocumentDetailsUpdated: true };
    case UPLOAD_OPERATOR_IDENTITY_DOCUMENTS[REQUEST]:
      return { ...state, operatorIdentityDocumentUploaded: false, identityDocData: {} };
    case UPLOAD_OPERATOR_IDENTITY_DOCUMENTS[SUCCESS]:
      if (action.payload.docType == 'VEH_DECLARATION') {
        return {
          ...state,
          vehDecFrontResourceKey: action.response[0].data.data.imgResourceKey,
          operatorIdentityDocumentUploaded: true,
        };
      } else {
        if (action.payload.fileSide == 'front') {
          return {
            ...state,
            frontImgResourceKey: action.response[0].data.data.imgResourceKey,
            operatorIdentityDocumentUploaded: true,
          };
        } else if (action.payload.fileSide == 'back') {
          return {
            ...state,
            backImgResourceKey: action.response[0].data.data.imgResourceKey,
            operatorIdentityDocumentUploaded: true,
          };
        } else {
          return {
            ...state,
          };
        }
      }

    case UPDATE_OPERATOR_TDS_DETAILS[REQUEST]:
      return { ...state, operatorTdsDetailsUploaded: false };
    case UPDATE_OPERATOR_TDS_DETAILS[SUCCESS]:
      return { ...state, operatorTdsDetailsUploaded: true };
    case SETTLE_TRIP[REQUEST]:
      return { ...state, tripSettled: false };
    case SETTLE_TRIP[SUCCESS]:
      return { ...state, tripSettled: true };
    case GET_FILE_VIEW[REQUEST]:
      return { ...state, fileUrl: '' };
    case GET_FILE_VIEW[SUCCESS]:
      return { ...state, fileUrl: action.response.viewUrl };
    case GET_TDS_VIEW_URL[REQUEST]:
      return { ...state, tdsFileUrl: '' };
    case GET_TDS_VIEW_URL[SUCCESS]:
      return { ...state, tdsFileUrl: action.response.viewUrl };
    case GET_TDS_FILE_UPLOAD[REQUEST]:
      return { ...state, tdsFileUploaded: false, tdsFileName: '' };
    case GET_TDS_FILE_UPLOAD[SUCCESS]:
      return { ...state, tdsFileUploaded: true, tdsFileName: action.response };
    case GET_FILE_UPLOAD[REQUEST]:
      return { ...state, fileUploaded: false, fileName: '' };
    case GET_FILE_UPLOAD[SUCCESS]:
      if (action.payload.type === 'AADHAAR')
        return {
          ...state,
          aadharUploaded: true,
          chequeUploaded: false,
          panUploaded: false,
          fileName: action.response,
        };
      else if (action.payload.type === 'PAN')
        return {
          ...state,
          aadharUploaded: false,
          chequeUploaded: false,
          panUploaded: true,
          fileName: action.response,
        };
      else if (action.payload.type === 'CHEQUE')
        return {
          ...state,
          aadharUploaded: false,
          chequeUploaded: true,
          panUploaded: false,
          fileName: action.response,
        };
      else {
        return {
          ...state,
        };
      }
    case CREATE_BANK_ACCOUNT[REQUEST]:
      return { ...state, bankCreated: false, bankAccountOtpDetails: null };
    case CREATE_BANK_ACCOUNT[SUCCESS]:
      // Check if OTP is required
      if (action.response && action.response.otpRequired === true) {
        return {
          ...state,
          bankCreated: false,
          bankAccountOtpDetails: {
            otpRequired: true,
            otpId: action.response.otpId,
            otpSendTo: action.response.otpSendTo,
            bankAccountData: action.requestPayload,
            isEdit: false,
          },
        };
      }
      return { ...state, bankCreated: true, bankAccountOtpDetails: null };
    case EDIT_BANK_ACCOUNT[REQUEST]:
      return { ...state, bankEdited: false, bankAccountOtpDetails: null };
    case EDIT_BANK_ACCOUNT[SUCCESS]:
      // Check if OTP is required
      if (action.response && action.response.otpRequired === true) {
        return {
          ...state,
          bankEdited: false,
          bankAccountOtpDetails: {
            otpRequired: true,
            otpId: action.response.otpId,
            otpSendTo: action.response.otpSendTo,
            bankAccountData: action.requestPayload,
            isEdit: true,
          },
        };
      }
      return { ...state, bankEdited: true, bankAccountOtpDetails: null };
    case DISABLE_ACCOUNT[REQUEST]:
      return { ...state, bankDisabled: false };
    case DISABLE_ACCOUNT[SUCCESS]:
      return { ...state, bankDisabled: true };
    case SEND_TO_THIRD_PARTY[REQUEST]:
      return { ...state, sentToThirdParty: false };
    case SEND_TO_THIRD_PARTY[SUCCESS]:
      return { ...state, sentToThirdParty: true };
    case ADD_TDS_DEC[REQUEST]:
      return { ...state, addedTdsDeclaration: false, addTdsDecErrorMsg: '' };
    case ADD_TDS_DEC[SUCCESS]:
      return { ...state, addedTdsDeclaration: true };
    case ADD_TDS_DEC[FAILURE]:
      return { ...state, addedTdsDeclaration: false, addTdsDecErrorMsg: action.response.message };
    case EDIT_TDS_DEC[REQUEST]:
      return { ...state, updatedTdsDeclaration: false, addTdsDecErrorMsg: '' };
    case EDIT_TDS_DEC[SUCCESS]:
      return { ...state, updatedTdsDeclaration: true };
    case EDIT_TDS_DEC[FAILURE]:
      return { ...state, updatedTdsDeclaration: false, addTdsDecErrorMsg: action.response.message };
    case GET_LANES_OPTIONS[REQUEST]:
      return { ...state, zonesWithDestinations: [] };
    case GET_LANES_OPTIONS[SUCCESS]:
      return { ...state, zonesWithDestinations: action.response.destinations };
    case EDIT_ONBOARDING_DEATILS[REQUEST]:
      return { ...state, onboardingDetailsUpdated: false, onboardingDetailsUpdateFailMsg: '' };
    case EDIT_ONBOARDING_DEATILS[FAILURE]:
      return { ...state, onboardingDetailsUpdated: false, onboardingDetailsUpdateFailMsg: action.response.message };
    case EDIT_ONBOARDING_DEATILS[SUCCESS]:
      return { ...state, onboardingDetailsUpdated: true, onboardingDetailsUpdateFailMsg: '' };
    case GET_ODVT_LIST[REQUEST]:
      return { ...state, odvtList: [], isFetchingOdvtList: false };
    case GET_ODVT_LIST[SUCCESS]:
      return { ...state, odvtList: action.response.odvtList, isFetchingOdvtList: false };
    case GET_ODVT_LIST[FAILURE]:
      return { ...state, odvtList: [], isFetchingOdvtList: false };
    case GET_VEHICLE_INFO[REQUEST]:
      return {
        ...state,
        vehicleSearchInfo: {
          isFetching: true,
          vehicleData: {},
        },
      };
    case GET_VEHICLE_INFO[SUCCESS]:
      return {
        ...state,
        vehicleSearchInfo: {
          isFetching: false,
          vehicleData: action.params,
        },
      };
    case GET_VEHICLE_INFO[FAILURE]:
      return {
        ...state,
        vehicleSearchInfo: {
          isFetching: false,
          vehicleData: {},
        },
      };
    case GET_KYC_HISTORY[REQUEST]:
      return {
        ...state,
        kycHistory: [],
      };
    case GET_KYC_HISTORY[SUCCESS]:
      return {
        ...state,
        kycHistory: action.response[0]?.data.history,
      };
    case GET_KYC_HISTORY[FAILURE]:
      return {
        ...state,
        kycHistory: [],
      };
    case GET_KYC_STATUS_REMARKS[REQUEST]:
      return {
        ...state,
        kycRemarks: [],
      };
    case GET_KYC_STATUS_REMARKS[SUCCESS]:
      return {
        ...state,
        kycRemarks: action.response[0]?.data.remarks,
      };
    case GET_KYC_STATUS_REMARKS[FAILURE]:
      return {
        ...state,
        kycRemarks: [],
      };
    case VERIFY_BANK_ACCOUNT_OTP[REQUEST]:
      return { ...state, bankCreated: false, bankEdited: false };
    case VERIFY_BANK_ACCOUNT_OTP[SUCCESS]:
      // Handle bank account OTP verification
      if (state.bankAccountOtpDetails) {
        const isEdit = state.bankAccountOtpDetails?.isEdit || false;
        return {
          ...state,
          bankCreated: !isEdit,
          bankEdited: isEdit,
          bankAccountOtpDetails: null,
        };
      }
      return state;
    case VERIFY_BANK_ACCOUNT_OTP[FAILURE]:
      return {
        ...state,
        bankCreated: false,
        bankEdited: false,
      };
    case RESEND_BANK_ACCOUNT_OTP[REQUEST]:
      return { ...state };
    case RESEND_BANK_ACCOUNT_OTP[SUCCESS]:
      return { ...state };
    case RESEND_BANK_ACCOUNT_OTP[FAILURE]:
      return { ...state };
    case CLEAR_BANK_ACCOUNT_OTP:
      return { 
        ...state, 
        bankAccountOtpDetails: null,
      };
    default:
      return state;
  }
}

export const getOperatorsList = (state) => state.operator.operatorsList;
export const getVehiclesList = (state) => state.operator.vehiclesList;
export const getSelectedOperator = (state) => state.operator.selectedOperator;
export const getOperatorBasicDetails = (state) => state.operator.operatorBasicDetails;
export const getPhoneNo = (state) => state.operator.phoneNo;
export const getOperatorAddressDetails = (state) => state.operator.operatorAddressDetails;
export const getOperatorCompliancesDetails = (state) => state.operator.operatorCompliancesDetails;
export const getOperatorDocumentDetails = (state) => state.operator.operatorDocumentDetails;
export const getIdentityDocumentUploadDetails = (state) => state.operator.identityDocumentUploadDetails;
export const getUploadedDocumentViewUrl = (state) => state.operator.uploadedDocumentViewUrl;
export const getUndertakingLinkSentStatus = (state) => state.operator.undertakingLinkSentStatus;
export const getBankAccounts = (state) => state.operator.bankAccounts;
export const getSettledTrips = (state) => state.operator.settledTrips;
export const getUnsettledTrips = (state) => state.operator.unsettledTrips;
export const getTotalRecoveryAmount = (state) => state.operator.totalRecoveryAmount;
export const getLedgerStream = (state) => state.operator.ledger;
export const getAadharUploaded = (state) => state.operator.aadharUploaded;
export const getPanUploaded = (state) => state.operator.panUploaded;
export const getTdsUploaded = (state) => state.operator.tdsUploaded;
export const getChequeUploaded = (state) => state.operator.chequeUploaded;
export const getFileName = (state) => state.operator.fileName;
export const getFileUrl = (state) => state.operator.fileUrl;
export const getTdsFileUrl = (state) => state.operator.tdsFileUrl;
export const getOperatorReducer = (state) => state.operator;
export const getOperatorDocuments = (state) => state.operator.operatorDocuments;
export const getZonesWithDestinations = (state) => state.operator.zonesWithDestinations;
export const getIdentityDocData = (state) => state.operator.identityDocData;
export const getFrontImgResourceKey = (state) => state.operator.frontImgResourceKey;
export const getBackImgResourceKey = (state) => state.operator.backImgResourceKey;
export const getVehDecFrontResourceKey = (state) => state.operator.getVehDecFrontResourceKey;
export const getUndertakingLinkErrorMessage = (state) => state.operator.undertakingLinkErrorMessage;
export const getTdsLinkErrorMessage = (state) => state.operator.tdsLinkErrorMessage;
export const getODVTListState = (state) => state.operator.odvtList;
export const vehicleInformation = (state) => state.operator.vehicleSearchInfo;
export const kycHistory = (state) => state.operator.kycHistory;
export const kycRemarks = (state) => state.operator.kycRemarks;
